export const enGb = {
  active: "Active",
  bankGroup: "Bank Group",
  configuration: "Configuration",
  configurationState: "Configuration state",
  configuredCurrencies: "Configured Currencies",
  country: "Country",
  errorDescription: "We couldn't load the bank list. Please try again later.",
  errorHeader: "Something went wrong",
  inactive: "Inactive",
  institution: "Bank",
  no: "No",
  pisStatus: "PIS Status",
  pisVisible: "PIS Visible",
  reset: "Reset",
  resetSuccess: "Configuration reset successfully",
  selectCustomer: "Select a customer",
  state: "State",
  stateCustom: "custom",
  stateDefault: "default",
  toggleSuccess: "Configuration updated successfully",
  toViewBankListSelectCustomer:
    "To view the bank list, please select a customer.",
  yes: "Yes",
} as const;
